import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { useResponsive } from '../../hooks/useResponsive'
import NavPC from './NavPC'
import NavSP from './NavSP'

export type NavProps = BoxProps & {}

const Nav: React.FC<NavProps> = ({ ...others }) => {
  const isPC = useResponsive(false, true)
  return (
    <>
      <Box pos="fixed" {...others}>
        <Box pos="fixed" minH="100vh" overflowY={['scroll', 'hidden']} h="100%">
          {isPC ? <NavPC /> : <NavSP />}
        </Box>
      </Box>
    </>
  )
}

export default Nav
